import styled from 'styled-components';

const ButtonWrapper = styled.div`
  display: flex;
`;

export default ButtonWrapper;



// WEBPACK FOOTER //
// ./components/_common/InlineEditableField/ButtonWrapper.js